export { Sparkles as default } from './Sparkles';
